import React from "react";
import Card from "@material-tailwind/react/Card";
import CardImage from "@material-tailwind/react/CardImage";
import CardBody from "@material-tailwind/react/CardBody";
import { Button, CardFooter } from "@material-tailwind/react";

interface CryptoCardProps {
  img: string;
  name: string;
  description: string;
  buttonStatus: 'available' | 'not_available' | 'coming_soon';
  link: string;
  /** The chain's page on the snapshot site, when it has one. */
  snapshotsUrl?: string;
}

export default function CryptoCard(props: CryptoCardProps) {

    return (
        <Card className="bg-transparent crypto-card flex flex-col">
            <div className="flex items-center p-4 pb-2">
                <CardImage
                    className='card-img2 mr-3'
                    src={props.img}
                    alt={`${props.name} logo`}
                />
                <h3 className="card-title text-left">{props.name}</h3>
            </div>
            <CardBody className="pt-2 text-left">
                <p className="card-description text-left py-5">
                    {props.description}
                </p>
                {/* Here rather than beside the button, so every card's button sits on the same line. */}
                {props.snapshotsUrl && (
                    <a className='card-link' href={props.snapshotsUrl}>
                        {props.name} node snapshots <span aria-hidden='true'>↗</span>
                    </a>
                )}
            </CardBody>
            <CardFooter className='h-full flex items-end'>
                {props.buttonStatus === 'available' ? (
                    <a href={props.link} target="_blank" rel="noopener noreferrer">
                        <Button
                            buttonType="filled"
                            size="lg"
                            rounded={false}
                            block={false}
                            iconOnly={false}
                            className='button-card'
                        >
                            Stake Now
                        </Button>
                    </a>
                ) : (
                    <Button
                        buttonType="filled"
                        size="lg"
                        rounded={false}
                        block={false}
                        iconOnly={false}
                        disabled={true}
                        className="button-card-disabled"
                    >
                        {props.buttonStatus === 'coming_soon' ? 'Coming Soon' : 'Not Available'}
                    </Button>
                )}
            </CardFooter>
        </Card>
    );
}